import { createContext, useReducer, useEffect } from "react";

const StateContext = createContext();

export const StateConsumer = StateContext.Consumer;
export default StateContext;
